// Edit profile, contact links and skills here.
export const PROFILE = {
  name: "Hades",
  available: true,
  details: [
    { label: "Role", value: "Developer & Digital Creator" },
    { label: "Focus", value: "Web Development, Software & AI" },
    { label: "Approach", value: "Design, Engineering & Problem Solving" },
  ],
};

// Placeholders: replace with real details. Empty string hides a link.
export const CONTACT = {
  email: "",
  github: "",
  discord: "https://discord.gg/3f",
  linkedin: "",
};

export const NAV_LINKS = [
  { id: "home", label: "Home", target: "#top" },
  { id: "about", label: "About", target: "#about" },
  { id: "skills", label: "Skills", target: "#skills" },
  { id: "projects", label: "Projects", target: "#work" },
  { id: "contact", label: "Contact", target: "#contact" },
];

export const PRINCIPLES = [
  { title: "Precision", text: "Every detail matters." },
  { title: "Innovation", text: "Always exploring better solutions." },
  { title: "Craftsmanship", text: "Building with purpose and quality." },
];

export const SKILLS = [
  { id: "web", icon: "code", title: "Web Development", items: ["HTML5", "CSS3", "JavaScript", "TypeScript", "React", "Next.js"] },
  { id: "backend", icon: "server", title: "Backend & APIs", items: ["Node.js", "REST APIs", "Database Integration", "Authentication & Authorization"] },
  { id: "automation", icon: "workflow", title: "Programming & Automation", items: ["Python", "JavaScript Automation", "Discord Bot Development", "API Integrations"] },
  { id: "ai", icon: "sparkles", title: "AI & Emerging Technology", items: ["AI-powered applications", "AI API integration", "Intelligent automation", "Experimental software projects"] },
];

export const PHILOSOPHY = [
  { n: "01", title: "Thoughtful Design", text: "Every interface should be clear, intuitive, and purposeful." },
  { n: "02", title: "Reliable Engineering", text: "Clean architecture, maintainability, performance, and security matter." },
  { n: "03", title: "Continuous Evolution", text: "Every project is an opportunity to experiment, improve, and learn." },
];

export const PROJECT_TYPES = ["Website", "Web Application", "Software / Tool", "Discord Bot", "AI Integration", "Collaboration", "Other"];

export const MARQUEE = ["Crafted with intention", "Built to last", "Design", "Engineering", "Precision", "Clean code", "Quiet confidence"];
